import React from 'react';
import './VerLateral.css';
import ProgressBarAnimated from '../../Misc/Other/ProgressBarAnimated';

function TwoProgressBar(props) {
    const { title1, data1, unit1, title2, data2, unit2 } = props;

    return(
            <div id='div-progressbar-lateral'>
                <ProgressBarAnimated title={title1} min={0} max={100} now={data1} percentage={data1*100/100} unit={unit1} variant={'success'}/>
                <ProgressBarAnimated title={title2} min={0} max={1000} now={data2} percentage={data2*100/1000} unit={unit2} variant={'warning'}/>
            </div>
    );
}

export default TwoProgressBar